export default function(entityArray, userDefaultTeamId) {
    if (!userDefaultTeamId || userDefaultTeamId === -1) return entityArray
    let orderedentities = entityArray.sort((a, b) => {
        let ownedA = a.teamId === userDefaultTeamId
        let ownedB = b.teamId === userDefaultTeamId
        if (ownedA === ownedB) {
            let nameA = a.name.toUpperCase()
            let nameB = b.name.toUpperCase()
            if (nameA < nameB) {
                return -1
            }
            if (nameA > nameB) {
                return 1
            }
            // names must be equal??
            return 0
        }
        return ownedA ? -1 : 1
    })
    return orderedentities
}
